import React, { useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { getCurrentUser } from "aws-amplify/auth";
import { useSelector } from "react-redux";
import { UNAUTHENTICATED } from "../../constants";

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  if (user.authState === "loading") {
    return <div>Loading...</div>;
  }
  if (user.authState === UNAUTHENTICATED) {
    return <Navigate to={"/login"} replace={true} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
